<template>
  <div style="background-color: #eeeeee">
    <my-component-header></my-component-header>
    <!-- 视频 -->
    <div style="width: 100%; padding-top: 70px">
      <video
        style="width: 100%; object-fit: cover; z-index: 1"
        autoplay
        loop
        muted
        playsinline
      >
        <source
          src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/1736502710528.mp4"
          type="video/mp4"
        />
      </video>
    </div>

    <!-- 科学养宠 -->
    <div class="centered-div" style="background-color: #ffffff">
      <div
        class="header-section"
        style="
          height: 120px;
          border-radius: 20px 20px 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: -124px;
        "
      >
        <div
          class="inner-div"
          style="
            flex: 0.7;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            style="width: 100px; height: 120px; object-fit: cover"
            src="/首页/k.png"
            alt=""
          />
        </div>
        <div class="inner-div" style="flex: 1; text-align: left; color: black">
          <h1 style="margin: 0">科学养宠 专宠专用</h1>
          <span style="font-size: 9px"
            >PET-KEEPING BY SCIENCE, CUSTOMIZED PRODUCTS FOR PET</span
          >
        </div>
      </div>

      <div class="bottom-section">
        <img style="width: 100%" :src="currentImage" alt="" />
      </div>

      <div class="container-category">
        <div class="child">
          <h1 class="title-bold" style="margin-top: 60px">7 PRODUCT LINES</h1>
        </div>
        <div class="child">
          <h2 class="title-bold" style="margin-top: -10px">七大品类</h2>
        </div>
        <div class="child flex-container">
          <img class="product-icon" src="/首页/line.png" alt="产品线图标" />
        </div>
      </div>

      <div>
        <div class="product-list">
          <div class="product-item">
            <div class="product-image-container">
              <img src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/09c09202412261528102020.png" alt="猫主粮" />
            </div>
            <h3 class="product-name">猫主粮</h3>
            <p class="product-details">CAT STAPLE FOOD</p>
          </div>

          <div class="product-item">
            <div class="product-image-container">
              <img src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/8a8a3202412261528218162.png" alt="犬主粮" />
            </div>
            <h3 class="product-name">犬主粮</h3>
            <p class="product-details">DOG STAPLE FOOD</p>
          </div>

          <div class="product-item">
            <div class="product-image-container">
              <img src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/d4bce20241226152757576.png" alt="猫零食" />
            </div>
            <h3 class="product-name">猫零食</h3>
            <p class="product-details">CAT SNACKS</p>
          </div>

          <div class="product-item">
            <div class="product-image-container">
              <img src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/42113202412261528173683.png" alt="犬零食" />
            </div>
            <h3 class="product-name">犬零食</h3>
            <p class="product-details">DOG SNACKS</p>
          </div>
        </div>

        <div class="product-list" style="margin-top: 25px;">
          <div class="product-item">
            <div class="product-image-container">
              <img src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/764fe202412261528067808.png" alt="用品" />
            </div>
            <h3 class="product-name">用品</h3>
            <p class="product-details">SUPPLIES</p>
          </div>

          <div class="product-item">
            <div class="product-image-container">
              <img src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/b2614202412261528376138.png" alt="营养品" />
            </div>
            <h3 class="product-name">营养品</h3>
            <p class="product-details">NUTRITIONAL SUPPLEMENT</p>
          </div>

          <div class="product-item">
            <div class="product-image-container">
              <img src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/e5cfa202412261528329947.png" alt="药品" />
            </div>
            <h3 class="product-name">药品</h3>
            <p class="product-details">VETERINARY DRUGS</p>
          </div>
        </div>
      </div>


      <div class="container-category" style="height: 200px">
        <div class="child">
          <h1 class="title-bold" style="margin-top: 60px">HONORARY AWARD</h1>
        </div>
        <div class="child">
          <h2 class="title-bold" style="margin-top: -10px">荣誉资质</h2>
        </div>
        <div class="child flex-container">
          <img class="product-icon" src="/首页/line.png" alt="产品线图标" />
        </div>
      </div>

      <div class="bottom-section" style="background-color: #eeeeee">
        <img
          style="width: 100%; height: auto; "
          src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/%E5%AE%98%E7%BD%91/C5725292-FFFB-4b5f-87C8-74BE78F3F0E0.png"
          alt=""
        />
      </div>
    </div>

    <div class="swipercom">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperOptionMTCX">
        <swiper-slide
            v-for="(item, index) in peGoods"
            :key="index"
            style="
            height: 370px;
            background-color: #ffffff;
            width: 80vw;
            border-radius: 20px;
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            padding: 10px;
            box-sizing: border-box;
          "
        >
          <div style="flex: 1; display: flex; align-items: center; justify-content: center; background-color: transparent; min-height: 0;">
            <img
                :src="item.image"
                :alt="item.title"
                style="max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain;"
            />
          </div>
          <div style="flex-shrink: 0; padding: 10px 5px; min-height: 60px; display: flex; align-items: center; justify-content: center;">
            <p style="margin: 0; text-align: center; font-size: 14px; line-height: 1.4; max-height: 40px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" v-html="item.title"></p>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="about-container">
      <!-- 左边图片 -->
      <div class="image-section">
        <img
          src="https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/32825202412261604195605.png"
          alt="关于我们图片"
          class="about-image"
        />
      </div>

      <!-- 右边文字 -->
      <div class="content-section">
        <div class="content-header">
          <h4 class="about-subtitle">ABOUT US</h4>
        </div>

        <div class="title-container">
          <h1 class="about-title">用专业帮助宠物更健康</h1>
          <h1 class="about-title">养宠更科学，陪伴更长久</h1>
        </div>
        <div class="content-description">
          <p class="about-text">
            凯锐思，山东凯锐思动物营养有限公司旗下品牌。2017年，山东凯<br />
            锐思动物营养有限公司开始进入宠物食品领域，与市场均以通用产品<br />
            为主不同，凯锐思品牌产品一上线就主打“安全”和“科学配方”，<br />
            并针对不同品种、不同生命阶段、不同生理状况研发宠粮，开创多种<br />
            适合不同场景需求的配方、技术与工艺，累计服务1500万中国养宠家庭。
          </p>
        </div>
      </div>
    </div>

    <my-component-buttom></my-component-buttom>
  </div>
</template>

<script>
import MyComponentBottom from "@/views/MyComponent-Bottom.vue";
import MyComponentHeader from "@/views/MyComponent-Header.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "Swiper",
  components: {
    "my-component-buttom": MyComponentBottom,
    "my-component-header": MyComponentHeader,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      intervalId2: null,
      images: [
        "https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/ba3e9202412271338176008.jpg",
        "https://keres-shop-map.oss-cn-hangzhou.aliyuncs.com/attach/2024/12/92539202412271338102795.jpg",
      ],
      currentIndex: 0,
      intervalId: null,
      hoverTimeout: null,
      showDropdown: false,
      page: [
        { name: "动态新闻", url: "brandDynamics" },
        { name: "企业产品", url: "stapleFoodGrain" },
        { name: "联系方式", url: "contactUs" },
        { name: "猫粮", url: "stapleFoodGrain" },
        { name: "狗粮", url: "stapleFoodGrain" },
      ],
      peGoods: [
        {
          title: "年度优秀品牌<br>凯锐思",
          image: "/首页/奖杯/outstandingBrandYear.jpg",
        },
        {
          title: "最佳人气品牌<br>凯锐思",
          image: "/首页/奖杯/bestPopularBrand.jpg",
        },
        {
          title: "最受消费者喜爱国货品牌<br>凯锐思",
          image: "/首页/奖杯/mostPopularDomesticBrandAmongConsumers.jpg",
        },
        {
          title: "天猫宠物会员运营<br>最具规模店铺",
          image: "/首页/奖杯/tmallPetMemberOperation.jpg",
        },
        {
          title: "物流服务杰出品牌<br>凯锐思",
          image: "/首页/奖杯/outstandingBrandLogisticsServices.jpg",
        },
        {
          title: "最佳合作伙伴奖<br>凯锐思",
          image: "/首页/奖杯/bestPartnerAward.jpg",
        },
        {
          title: "年度优秀品牌<br>凯锐思",
          image: "/首页/奖杯/画板 1.jpg",
        },
        {
          title: "最佳人气品牌<br>凯锐思",
          image: "/首页/奖杯/画板 1 拷贝.jpg",
        },
        {
          title: "最受消费者喜爱国货品牌<br>凯锐思",
          image: "/首页/奖杯/画板 1 拷贝 2.jpg",
        },
        {
          title: "天猫宠物会员运营<br>最具规模店铺",
          image: "/首页/奖杯/画板 1 拷贝 3.jpg",
        },
        {
          title: "物流服务杰出品牌<br>凯锐思",
          image: "/首页/奖杯/画板 1 拷贝 4.jpg",
        },
        {
          title: "2024年度用户喜爱的品牌<br>(猫砂)",
          image: "/首页/奖杯/2024年度用户喜爱的品牌【猫砂】.jpg",
        },
        {
          title: "2024年度用户喜爱的品牌<br>(国产犬零食)",
          image: "/首页/奖杯/2024年度用户喜爱的品牌【国产犬零食】.jpg",
        },
        {
          title: "荣获2025年第12届<br>京宠展主粮类《金奖》",
          image: "/首页/奖杯/1、首页_14 - 副本.jpg",
        },
        {
          title: "京东宠物2024年度<br>《增长先锋品牌奖》",
          image: "/首页/奖杯/京东.jpg",
        },
        // {
        //   title: "比熊犬",
        //   image: "/首页/奖杯/bixiongCatFood.png",
        // },
        // {
        //   title: "布偶猫",
        //   image: "/首页/奖杯/muppetCatFood.png",
        // },
      ],

      swiperOption: {
        loop: true,
        spaceBetween: 30, // 设置一个正数间距
        initialSlide: 0,
        observer: true,
        observeParents: true,
        centeredSlides: false,
        slidesPerView: 5,
        effect: "slide",
        speed: 1400,
        autoplay: {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    },
  },
  mounted() {
    this.startSlideshow();
  },
  beforeDestroy() {
    this.stopSlideshow();
    this.stopShuffling2();
  },
  methods: {
    shuffleArray2(array) {
      const shuffled = array.slice(); // 创建数组副本以避免修改原始数据
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // 交换元素
      }
      return shuffled;
    },
    stopShuffling2() {
      if (this.intervalId2) {
        clearInterval(this.intervalId2);
      }
    },
    startSlideshow() {
      this.intervalId = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }, 3000); // 每3秒切换一次图片
    },
    stopSlideshow() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    onDropdownEnter() {
      clearTimeout(this.hoverTimeout);
      this.showDropdown = true;
    },
    onDropdownLeave() {
      this.hoverTimeout = setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
/**
  ABOUT US
 */
.about-container {
  margin: 50px auto 0;
  display: flex;
  width: 100%;
  max-width: 1200px;
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  align-items: center;
  min-height: 500px;
}

/* 左边图片区域 */
.image-section {
  flex: 0 0 53%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 40px;
}

.about-image {
  width: 100%;
  max-width: 500px;
  height: auto;
  aspect-ratio: 1/1;
  object-fit: contain;
}

/* 右边文字区域 */
.content-section {
  flex: 0 0 47%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;
}

.content-header {
  margin-bottom: clamp(15px, 2vw, 25px);
}

.about-subtitle {
  color: black;
  font-size: clamp(14px, 1.2vw, 18px);
  margin: 0;
  font-weight: 600;
  letter-spacing: 2px;
}

.title-container {
  width: 100%;
  margin-bottom: clamp(30px, 6vw, 80px);
}

.about-title {
  font-weight: bold;
  color: black;
  margin: 0;
  text-align: left;
  line-height: 1.3;
  width: 100%;
}

.main-title {
  font-size: clamp(20px, 2.8vw, 36px);
  margin-bottom: clamp(8px, 1vw, 15px);
}

.sub-title {
  font-size: clamp(18px, 2.5vw, 32px);
}

.content-description {
  width: 100%;
}

.about-text {
  line-height: clamp(1.6, 2vw, 2);
  font-size: clamp(12px, 1.4vw, 16px);
  color: black;
  margin: 0;
  text-align: left;
  max-width: 100%;
}

/* 平板端适配 */
@media (max-width: 992px) {
  .about-container {
    padding: 0 30px;
    min-height: 400px;
  }

  .image-section {
    flex: 0 0 50%;
    padding-right: 20px;
  }

  .content-section {
    flex: 0 0 50%;
    padding-left: 20px;
  }

  .about-subtitle {
    font-size: clamp(13px, 1.5vw, 16px);
  }

  .main-title {
    font-size: clamp(18px, 3vw, 28px);
  }

  .sub-title {
    font-size: clamp(16px, 2.8vw, 26px);
  }

  .about-text {
    font-size: clamp(11px, 1.6vw, 14px);
    line-height: clamp(1.5, 1.8vw, 1.8);
  }
}

/* 小平板端 */
@media (max-width: 768px) {
  .about-container {
    padding: 0 20px;
    min-height: 350px;
  }

  .image-section {
    flex: 0 0 45%;
    padding-right: 15px;
  }

  .content-section {
    flex: 0 0 55%;
    padding-left: 15px;
  }

  .about-subtitle {
    font-size: 12px;
  }

  .main-title {
    font-size: 16px;
  }

  .sub-title {
    font-size: 15px;
  }

  .about-text {
    font-size: 11px;
    line-height: 1.6;
  }
}

/* 手机端 */
@media (max-width: 576px) {
  .about-container {
    padding: 0 15px;
    min-height: 300px;
    margin-top: 30px;
  }

  .image-section {
    flex: 0 0 40%;
    padding-right: 10px;
  }

  .content-section {
    flex: 0 0 60%;
    padding-left: 10px;
  }

  .content-header {
    margin-bottom: 10px;
  }

  .about-subtitle {
    font-size: 11px;
    letter-spacing: 1px;
  }

  .title-container {
    margin-bottom: 20px;
  }

  .main-title {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .sub-title {
    font-size: 13px;
  }

  .about-text {
    font-size: 10px;
    line-height: 1.5;
  }
}

/* 超小手机端 */
@media (max-width: 400px) {
  .about-container {
    flex-direction: column;
    min-height: auto;
  }

  .image-section,
  .content-section {
    flex: none;
    width: 100%;
    padding: 0;
  }

  .image-section {
    margin-bottom: 20px;
    justify-content: center;
  }

  .about-image {
    max-width: 200px;
  }

  .content-section {
    text-align: center;
    align-items: center;
  }

  .about-title,
  .about-text {
    text-align: center;
  }

  .about-subtitle {
    font-size: 10px;
  }

  .main-title {
    font-size: 16px;
  }

  .sub-title {
    font-size: 15px;
  }

  .about-text {
    font-size: 12px;
    line-height: 1.6;
  }
}

/* 大屏幕适配 */
@media (min-width: 1400px) {
  .about-container {
    max-width: 1400px;
  }

  .about-image {
    max-width: 600px;
  }

  .about-subtitle {
    font-size: 20px;
  }

  .main-title {
    font-size: 40px;
  }

  .sub-title {
    font-size: 36px;
  }

  .about-text {
    font-size: 18px;
    line-height: 2.2;
  }
}

/**
  7大品类图片
 */
.product-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  margin-top: 60px;
  align-items: stretch; /* 重要：让所有项目高度一致 */
}

.product-item {
  width: calc(25% - 10px);
  border: 1px solid #ccc;
  padding: 15px;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 340px;
}

.product-image-container {
  width: 100%;
  height: 220px; /* 统一图片容器高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  flex-shrink: 0;
}

.product-image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 5px;
  flex-shrink: 0;
}

.product-details {
  font-size: 14px;
  color: #777;
  margin: 0;
  flex-shrink: 0;
}

/* 自动填充剩余空间的伪元素 */
.product-item::after {
  content: '';
  flex: 1;
}

/* 响应式 */
@media (max-width: 992px) {
  .product-item {
    width: calc(50% - 10px);
    min-height: 360px;
  }
}

@media (max-width: 576px) {
  .product-item {
    width: 100%;
    min-height: 340px;
  }
}

/* 媒体查询 - PC 通常为 1366px 以上 */
@media (min-width: 1367px) {
  .swiperOptionMTCX {
  }
}
/* 媒体查询 - 笔记本通常为 1366px 以下 */
@media (max-width: 1366px) {
  .swiperOptionMTCX {
  }
}
.product-center .dropdown-menu {
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 99999999;
  position: absolute; /* 使用绝对定位 */
  background-color: #ffffff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.product-center:hover .dropdown-menu,
.product-center .dropdown-menu:hover {
  display: block;
  opacity: 1;
  visibility: visible;
}
.dropdown-menu a {
  display: block;
  text-decoration: none;
  color: #333;
  font-size: 14px;
  white-space: nowrap;
}
.centered-div {
  width: 75%; /* 设置您想要的宽度 */
  margin-left: auto;
  margin-right: auto; /* 水平居中 */
  position: relative; /* 确保子元素的绝对定位相对于此容器 */
  display: flex;
  flex-direction: column; /* 确保子元素垂直排列 */
}
.inner-div {
  text-align: center; /* 如果您希望文本也居中 */
  padding: 20px; /* 可选：添加内边距 */
}
/* 头部区域 */
.header-section {
  background-color: #ffffff;
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center; /* 垂直居中对齐 */
}
/* 底部区域 */
.bottom-section {
  margin-top: auto; /* 推挤到最下方 */
}
.container-category {
  display: flex;
  flex-direction: column; /* 子元素垂直排列 */
  align-items: center; /* 沿交叉轴（水平方向）居中 */
  justify-content: space-between; /* 更好地分布子元素 */
  gap: 10px; /* 子元素之间的间距 */
  height: 150px; /* 设置父容器高度 */
}
.child {
  width: 100%; /* 确保子元素宽度一致 */
  text-align: center; /* 文本居中 */
  margin: 0; /* 移除默认上下边距 */
}
.title-bold {
  font-weight: bold;
  margin: 0; /* 移除默认上下边距 */
}
/* 使用 Flexbox 控制图片的位置 */
.child.flex-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: flex-start; /* 垂直对齐到顶部 */
  height: 100%; /* 确保子容器高度与父容器一致 */
  position: relative; /* 确保绝对定位的子元素相对于此容器 */
}
.product-icon {
  height: 15px;
  width: auto; /* 保持图片比例 */
  margin-top: -5px; /* 微调图片位置，如果需要 */
}
/* 七大品类 */
.product-list {
  display: flex;
  flex-wrap: nowrap; /* 不换行 */
  justify-content: center; /* 居中对齐 */
  gap: 2vw; /* 控制项目之间的间距 */
  padding: 0 0.5vw; /* 确保左右有适当的间距 */
}
.product-item {
  width: 200px;
  height: 240px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.product-item img {
  margin-top: 30px; /* 确保图片与文本之间有足够的空间 */
}
.product-name {
  color: #1c1c1d;
  font-size: 1rem; /* 使用相对字体大小 */
  margin-top: 5px;
  margin-bottom: 0.5rem; /* h3 和 p 之间的间距 */
}
.product-details {
  font-size: 0.8rem; /* 使用相对字体大小 */
  color: #1c1c1d;
  margin-top: 0;
  margin-bottom: 0;
}
.img-details {
  height: 310px;
  width: 205px;
}
/* 内部容器样式 */
.inner-container {
  display: flex;
  flex-direction: column;
}
/* 子项样式 */
.child-item {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: left;
}
/* 外部 CSS 文件或 <style> 标签内的样式 */
.dropdown-menu .link-text {
  display: block;
  text-decoration: none;
  font-size: 16px;
  color: #393939; /* 默认字体颜色 */
  padding: 8px 16px; /* 可选：增加一些内边距使点击区域更大 */
  transition: color 0.3s ease; /* 平滑过渡效果 */
}
.dropdown-menu .link-text:hover {
  color: #00d6a9; /* 悬停时字体颜色 */
}
</style>

<style lang="scss" scoped>
.swipercom {
  width: 100%;
  .swiper-slide {
    text-align: center;
    position: relative;
  }
  .swiper-pagination {
  }
  ::v-deep .swiper-pagination-bullet {
    width: 25px;
    height: 3px;
    border-radius: 5px;
  }
}
</style>
